import React from 'react';
import PropTypes from 'prop-types';
import { navigateTo } from 'gatsby-link';
import { Button } from 'reactstrap';

import './CardsBanner.scss';

const Card = props => (
  <div className="card-offshore">
    <i className="material-icons">{props.icon}</i>
    {/* card title */}
    <div className="card-offshore-title">{props.title}</div>
    {/* card body */}
    <div className="card-offshore-body">{props.children}</div>
    {/* en savoir plus */}
    <Button onClick={() => navigateTo(props.link)}>En savoir plus</Button>
  </div>
);

Card.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.object,
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/Main/home/Card.js